import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const PostBookAdd = (props) => {
  const [loading, setLoading] = useState(true);
  const [buffer, setBuffer] = useState([]);
  const [podOdb, setPodOdb] = useState(0);
  const [category, setCategory] = useState("EKONOMICZNA");
  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [street, setStreet] = useState("");
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [city, setCity] = useState("");
  const [postCode, setPostCode] = useState("");
  const [clientsAddress, setClientsAddress] = useState([]);
  const [courtAddress, setCourtAddress] = useState([]);
  const [bankAddress, setBankAddress] = useState([]);
  const [bank2Address, setBank2Address] = useState([]);
  const [addressBook, setAddressBook] = useState([]);
  const [bookMode, setBookMode] = useState("client");
  const [chooseAddress, setChooseAddres] = useState(1);
  const [closeSend, setCloseSend] = useState(false);
  const [buffers, setBuffers] = useState([]);
  const [addres, setAddress] = useState("");
  const [addressOptions, setAddressOptions] = useState([]);
  const [addressType, setAddressType] = useState("");
  const [desc, setDesc] = useState("");
  const [descA, setDescA] = useState("");

  const fetchBufferList = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBuforListPostBookList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBuffers(data.bufor);
        fetchClientAddress();
      })
      .catch((error) => {});
  };

  const fetchAdd = async () => {
    setLoading(false);
    var date = "";

    if (closeSend) {
      date =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() + 1 < 10
          ? "0" + (new Date().getDate() + 1)
          : new Date().getDate() + 1);
    } else {
      date =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate());
    }

    try {
      var body = {
        podOdb: podOdb,
        category: category,
        name1: name1,
        name2: name2,
        street: street,
        num1: num1,
        num2: num2,
        city: city,
        postCode: postCode,
        date: date,
        idBufor: buffers
          ? buffers.filter((el) => el.attributes.dataNadania === date).length >
            0
            ? buffers.filter((el) => el.attributes.dataNadania === date)[0]
                .attributes.idBufor
            : ""
          : "",
      };
    } catch (error) {}

    await fetch("https://apidevkppp.ftpeople.pl/addNewShipment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        checkLabel(
          data.retval[0].attributes.guid,
          data.retval[0].attributes.numerNadania
        );
      })
      .catch((error) => {});
  };

  const checkAddressBook = () => {
    var check = addressBook.filter((el) => {
      el.name === name1 &&
        el.street === street &&
        el.number === num1 &&
        el.postCode === postCode &&
        el.city === city;
    });

    if (check.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleOpenPdfInNewTab = (base64Pdf) => {
    try {
      var pdfData = `data:application/pdf;base64,${base64Pdf}`;

      var w = window.open("");

      if (w) {
        w.document.write(
          `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
        );
      } else {
        throw new Error("Failed to open a new tab.");
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      // } finally {
      //   if (w) w.document.close();
      // }
    }
  };

  const checkLabel = (guid, numerNadania) => {
    var body6 = {
      desc: desc,
      newNumNad: numerNadania,
      numNad: props.numNad,
    };

    fetch("https://apidevkppp.ftpeople.pl/updateDescPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body6),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    if (checkAddressBook) {
      var body7 = {
        name: name1,
        street: street,
        number: num1,
        postCode: postCode,
        city: city,
      };

      fetch("https://apidevkppp.ftpeople.pl/addAddressBook", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body7),
      })
        .then((response) => response.text())
        .then((data) => {})
        .catch((error) => {});
    }

    MySwal.fire({
      icon: "success",
      title: "Wydrukuj etykietę",
      text: numerNadania,
      confirmButtonText: "Dalej",
    }).then(async (result) => {
      var body = {
        guid: guid,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getLabelByGuid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          handleOpenPdfInNewTab(data.printResult[0].print);
          setPodOdb(0);
          setCategory("EKONOMICZNA");
          setName1("");
          setName2("");
          setStreet("");
          setNum1("");
          setNum2("");
          setCity("");
          setPostCode("");
          MySwal.fire({
            icon: "success",
            title: "Numer nadania",
            text: numerNadania,
          }).then(async (result) => {
            setLoading(false);
            props.close();
          });
        })
        .catch((error) => {});
    });
  };

  const fetchClientAddress = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data
          .filter((et) => et.additionalData !== "")
          .map((el) => {
            var tmp = el.additionalData
              .replaceAll("  ", "")
              .replaceAll("ul. ", "")
              .replaceAll("ul ", "")
              .replaceAll("|", " | ")
              .split("|")
              .filter((ep) => ep !== " ");

            tmp = tmp.filter(
              (t) => t.split(",")[2] !== "" && t.split(",")[2] !== " "
            );
            if (tmp.length > 0) {
              tmp.map((ex) => {
                var tmp2 = ex.replaceAll("  ", "").split(",");
                if (tmp2[2].split(";").length > 1) {
                  var fRec = tmp2[2].split(";")[0].split(" ");
                  var sRec = "";
                  if (tmp2[2].split(";")[1][0] === " ") {
                    sRec = tmp2[2].split(";")[1].replace(" ", "").split(" ");
                  } else {
                    sRec = tmp2[2].split(";")[1].split(" ");
                  }
                  if (sRec.length > 1 && fRec.length > 1) {
                    var newR = {
                      id: el.id,
                      name: tmp2[0],
                      street: fRec[0],
                      number: fRec[1],
                      postCode: sRec[0],
                      city: sRec[1].replaceAll(".", ""),
                      type: "client",
                    };
                    arr.push(newR);
                  }
                }
              });
            }
          });
        setClientsAddress(arr);
        var adr = arr;
        fetchCourtAddress(adr);
      })
      .catch((error) => {});
  };

  const fetchCourtAddress = async (adr) => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourtAddressPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          if (el.addressNew) {
            var obj = JSON.parse(el.addressNew);
            var newR = {
              id: el.id,
              name: el.name,
              street: obj.street,
              number: obj.number,
              postCode: obj.postCode,
              city: obj.city,
              type: "court",
            };
            arr.push(newR);
          }
        });

        setCourtAddress(arr);

        fetchBankAddress(adr.concat(arr));
      })
      .catch((error) => {});
  };

  const fetchBankAddress = async (adr) => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankLawOfficeAddressPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          if (el.addressNew) {
            var obj = JSON.parse(el.addressNew);
            var newR = {
              id: el.id,
              name: el.name.split(",")[0],
              street: obj.street,
              number: obj.number,
              postCode: obj.postCode,
              city: obj.city,
              type: "lawoffice",
            };
            arr.push(newR);
          }
        });

        setBankAddress(arr);
        fetchBank2Address(adr.concat(arr));
      })
      .catch((error) => {});
  };

  const fetchBank2Address = async (adr) => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddressPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          var obj = JSON.parse(el.addressNew);

          var newR = {
            id: el.id,
            name: el.nameLetter,
            street: obj.street,
            number: obj.number,
            postCode: obj.postCode,
            city: obj.city,
          };
          arr.push(newR);
        });

        setBank2Address(arr);

        fetchAddressBook(adr.concat(arr));
      })
      .catch((error) => {});
  };

  const fetchAddressBook = async (adr) => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getAddressBook", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          var newR = {
            id: el.id,
            name: el.name,
            street: el.street,
            number: el.number,
            postCode: el.postCode,
            city: el.city,
            type: "addressBook",
          };
          arr.push(newR);
        });

        setAddressBook(arr);
        setAddress(adr.concat(arr));

        var adrOptions = [];
        adr.concat(arr).map((el) => {
          adrOptions.push({
            label: `${el.name}: ${el.street} ${el.number}, ${el.postCode} ${el.city}`,
            value: {
              name: el.name,
              street: el.street,
              number: el.number,
              postCode: el.postCode,
              city: el.city,
              type: el.type,
            },
          });
        });

        setAddressOptions(adrOptions);

        fetchCloseSend();
      })
      .catch((error) => {});
  };

  const fetchCloseSend = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSendClose ", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var date =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate());

        if (date === data.date) {
          setCloseSend(true);
        } else {
          setCloseSend(false);
        }

        fetchDescA();
      })
      .catch((error) => {});
  };

  const fetchDescA = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPackageDesc", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDescA(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBufferList();
  };

  useEffect(() => {
    getData();
  }, []);

  const setDataByAddressBook = (e) => {
    var id = e.target.value;
    setChooseAddres(id);
    if (bookMode === "client") {
      var data = clientsAddress.filter((el) => +el.id === +id)[0];
      setName1(data.name);
      setNum1(data.number);
      setStreet(data.street);
      setPostCode(data.postCode);
      setCity(data.city);
    }
    if (bookMode === "court") {
      var data = courtAddress.filter((el) => +el.id === +id)[0];
      setName1(data.name);
      setNum1(data.number);
      setStreet(data.street);
      setPostCode(data.postCode);
      setCity(data.city);
    }

    if (bookMode === "bank") {
      var data = bankAddress.filter((el) => +el.id === +id)[0];
      setName1(data.name);
      setNum1(data.number);
      setStreet(data.street);
      setPostCode(data.postCode);
      setCity(data.city);
    }

    if (bookMode === "bank2") {
      var data = bank2Address.filter((el) => +el.id === +id)[0];
      setName1(data.name);
      setNum1(data.number);
      setStreet(data.street);
      setPostCode(data.postCode);
      setCity(data.city);
    }
  };

  const clearData = () => {
    setPodOdb(0);
    setCategory("EKONOMICZNA");
    setName1("");
    setName2("");
    setStreet("");
    setNum1("");
    setNum2("");
    setCity("");
    setPostCode("");
    setDesc("");
  };

  const createExcelDS = () => {
    var tab = [];
    tab.push(["ID", "Nazwa", "Ulica", "Numer", "Kod pocztowy", "Miasto"]);
    clientsAddress.map((el) => {
      tab.push([el.id, el.name, el.street, el.number, el.postCode, el.city]);
    });
    return tab;
  };

  const exportToExcelClients = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");

    return;
  };

  const createExcelBankDS = () => {
    var tab = [];
    tab.push(["ID", "Nazwa", "Ulica", "Numer", "Kod pocztowy", "Miasto"]);
    bankAddress.map((el) => {
      tab.push([el.id, el.name, el.street, el.number, el.postCode, el.city]);
    });
    return tab;
  };

  const exportToExcelBanks = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelBanksDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const createExcelBank2DS = () => {
    var tab = [];
    tab.push(["ID", "Nazwa", "Ulica", "Numer", "Kod pocztowy", "Miasto"]);
    bank2Address.map((el) => {
      tab.push([el.id, el.name, el.street, el.number, el.postCode, el.city]);
    });
    return tab;
  };

  const exportToExcelBanks2 = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelBank2DS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const createExcelCourtDS = () => {
    var tab = [];
    tab.push(["ID", "Nazwa", "Ulica", "Numer", "Kod pocztowy", "Miasto"]);
    courtAddress.map((el) => {
      tab.push([el.id, el.name, el.street, el.number, el.postCode, el.city]);
    });
    return tab;
  };

  const exportToExcelCourts = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelCourtDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const setAddressByOption = (e) => {
    var value = e.value;

    setAddressType(value.type);
    var name1Q = "";
    var name2Q = "";
    if (value.name.split(" ").length > 7) {
      value.name.split(" ").map((el, index) => {
        if (index <= 6) {
          name1Q = name1Q + " " + el;
        } else {
          name2Q = name2Q + " " + el;
        }
      });
    } else {
      name1Q = value.name;
    }
    setName1(name1Q);
    setName2(name2Q);
    setStreet(value.street);
    setNum1(value.number);
    setPostCode(value.postCode);
    setCity(value.city);
  };

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            <div id="asd">
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={addressOptions}
                onChange={setAddressByOption}
              />

              <div
                className="saveBoxAP"
                style={{ display: "none", gap: "2vw" }}
              >
                <button
                  className="paymentMenuButton"
                  onClick={exportToExcelClients}
                >
                  XLS KLIENCI
                </button>
                <button
                  className="paymentMenuButton"
                  onClick={exportToExcelCourts}
                >
                  XLS SĄDY
                </button>
                <button
                  className="paymentMenuButton"
                  onClick={exportToExcelBanks}
                >
                  XLS PEŁN. BANKÓW
                </button>
                <button
                  className="paymentMenuButton"
                  onClick={exportToExcelBanks2}
                >
                  XLS BANKI
                </button>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "5vh",
                width: "100%",
              }}
            ></div>
            <div id="asd1">
              <div className="inputBox" id="asd6">
                <div id="asd" className="inputCol_2">
                  <label>Potwierdzenie odbioru </label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={podOdb}
                    onChange={(e) => {
                      setPodOdb(e.target.value);
                    }}
                  >
                    <>
                      <option key={0} value={1}>
                        TAK
                      </option>
                      <option key={1} value={0}>
                        NIE
                      </option>
                    </>
                  </select>
                </div>
                <div id="asd" className="inputCol_2">
                  <label>Rodzaj przesyłki</label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={category}
                    onChange={(e) => {
                      setCategory(e.target.value);
                    }}
                  >
                    <>
                      <option key={0} value={"EKONOMICZNA"}>
                        EKONOMICZNA
                      </option>
                      <option key={1} value={"PRIORYTETOWA"}>
                        PRIORYTETOWA
                      </option>
                    </>
                  </select>
                </div>
              </div>

              <div className="inputBox" id="asd6">
                <div id="asd" className="inputCol_2">
                  <label>Nazwa 1</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={name1}
                    onChange={(e) => {
                      setName1(e.target.value);
                    }}
                  />
                </div>
                <div id="asd" className="inputCol_2">
                  <label>Nazwa 2</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={name2}
                    onChange={(e) => {
                      setName2(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div id="asd6" className="inputBox">
                <div id="asd" className="inputCol_2">
                  <label>Ulica</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={street}
                    onChange={(e) => {
                      setStreet(e.target.value);
                    }}
                  />
                </div>
                <div id="asd" className="inputCol_2">
                  <label>Numer domu</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={num1}
                    onChange={(e) => {
                      setNum1(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div id="asd6" className="inputBox">
                <div id="asd" className="inputCol_2">
                  <label>Numer lokalu</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={num2}
                    onChange={(e) => {
                      setNum2(e.target.value);
                    }}
                  />
                </div>
                <div id="asd" className="inputCol_2">
                  <label>Miejscowość</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={city}
                    onChange={(e) => {
                      setCity(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div id="asd6" className="inputBox">
                <div id="asd" className="inputCol_2">
                  <label>Kod pocztowy</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={postCode}
                    onChange={(e) => {
                      setPostCode(e.target.value);
                    }}
                  />
                </div>
                <div id="asd" className="inputCol_2">
                  <label>Predefiniowany opis</label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    onChange={(e) => {
                      setDesc(
                        descA.filter((el) => +el.id === +e.target.value)[0]
                          .content
                      );
                    }}
                  >
                    <>
                      {!desc ? (
                        <>
                          <option key={0} value={0}>
                            Wybierz...
                          </option>
                        </>
                      ) : (
                        ""
                      )}

                      {descA.map((el) => (
                        <>
                          <option key={el.id} value={el.id}>
                            {el.content}
                          </option>
                        </>
                      ))}
                    </>
                  </select>
                </div>
              </div>

              <div id="asd6" className="inputBox">
                <div className="inputCol_1" style={{ width: "100%" }}>
                  <label>Opis</label>
                  <textarea
                    style={{
                      boxSizing: "border-box",
                      resize: "none",
                      height: "10vh",
                    }}
                    value={desc}
                    onChange={(e) => {
                      setDesc(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div
                className="saveBoxAP"
                style={{ display: "flex", gap: "2vw" }}
              >
                <button className="paymentMenuButton" onClick={fetchAdd}>
                  dodaj
                </button>
                <button className="paymentMenuButton" onClick={clearData}>
                  wyczyść
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PostBookAdd;
